import { safeDefine } from "../../registration/safe-define.js";
import { VolumeIndicatorValueElement } from "../../ui/volume-indicator/value.js";
//#region src/define/ui/volume-indicator-value.ts
safeDefine(VolumeIndicatorValueElement);
//#endregion

//# sourceMappingURL=volume-indicator-value.js.map